import { Content } from "app/content";
import { UserContent } from "app/profile/model/model";

interface LocalisedText {
  [language: string]: string;
}

export interface CModule {
  _id: string;
  title: LocalisedText;
  description: LocalisedText;
  keywords?: LocalisedText;
  productId: string;
  orderno: number;
  contents: Array<string>; // Content._id's
  fullContents?: Array<Content>;
  userContents?: Array<UserContent>;
  contStates?: Array<number>;
  state?: number; // 0, 5, 9 like contents
  doneDate?: Date;
}
